import mixpanel from "mixpanel-browser";

const initializeMixpanel = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || "", {
    debug: true,
    api_host: process.env.REACT_APP_MIXPANEL_API,
  });
};

const actions = {
  initialize: initializeMixpanel,
  identify: (id: string) => mixpanel.identify(id),
  alias: (id: string) => mixpanel.alias(id),
  track: (name: any, props?: any) => mixpanel.track(name, props),
  people: {
    set: (props: any) => mixpanel.people.set(props),
  },
  register: (props: any) => mixpanel.register(props),
  reset: () => mixpanel.reset(),
};

export const Mixpanel = actions;
